module.exports = __webpack_public_path__ + "static/media/oq-icon.0cfefc86.jpg";